export default "__VITE_ASSET__C2H456Fl__"